// extracted by mini-css-extract-plugin
module.exports = {"container":"Description_container__3-cmj","col-3":"Description_col-3__1yrEY","col-9":"Description_col-9__49dCz"};